const Circle = (theme, translateX = 23, translateY = 35, symbolColor = '') => {
  const group = document.createElementNS('http://www.w3.org/2000/svg', 'g');
  group.setAttribute(
    'transform',
    `scale(0.5) translate(${translateX} ${translateY})`,
  );

  const circle = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'circle',
  );
  circle.setAttribute('cx', '12');
  circle.setAttribute('cy', '12');
  circle.setAttribute('r', '10');
  circle.setAttribute('fill', symbolColor);
  circle.setAttribute('stroke', 'none');

  group.appendChild(circle);
  return group;
};

export default Circle;
